import { Route, Outlet } from "react-router";
import { ActionsProvider } from "src/context/Actions/provider";
import { URLHandler } from "src/services/URLHandler";
import { useActionPlanRouter } from "src/components/Actions/ActionPlanRouter";
import { useCompanyMetadata } from "src/context/Company/Metadata/useCompanyMetadata";
import { useTranslation } from "react-i18next";

export const useTrajectoryCompanyRouter = () => {
    const actionPlanRouter = useActionPlanRouter();
    return <Route element={<ActionCompanyContext />}>{actionPlanRouter}</Route>;
};

const ActionCompanyContext = () => {
    const { t } = useTranslation();
    const { company, ssqVersion } = useCompanyMetadata();

    if (ssqVersion === undefined) {
        return (
            <>{t("trajectory.questionnaire_needed", "You must answer a questionnaire before entering Trajectory")}</>
        );
    }

    const ssq = ssqVersion.ssq;

    return (
        <ActionsProvider
            ssqVersion={ssqVersion}
            extraFilterForAction={{
                "startSsqPost.organization.id": company.id,
                "startSsqPost.ssqId": ssq.id,
            }}
            urls={{
                noActionPlan: () => URLHandler.company.actions.noActionPlan(company.id, ssq.id),
                planning: () => URLHandler.company.actions.planning(company.id, ssq.id),
                trajectory: () => URLHandler.company.actions.trajectory(company.id, ssq.id),
                trajectoryBarChart: () => URLHandler.company.actions.trajectoryBarChart(company.id, ssq.id),
                trajectoryCards: () => URLHandler.company.actions.trajectoryCards(company.id, ssq.id),
                catalog: () => URLHandler.company.actions.catalog(company.id, ssq.id),
                catalogList: () => URLHandler.company.actions.catalogList(company.id, ssq.id),
                catalogGroup: (actionId: number) =>
                    URLHandler.company.actions.catalogGroup(company.id, ssq.id, actionId),
                catalogGroupItem: (groupId: number, actionId: number) =>
                    URLHandler.company.actions.catalogGroupItem(company.id, ssq.id, groupId, actionId),
                editPlanning: (actionId: string) =>
                    URLHandler.company.actions.editPlanning(company.id, ssq.id, actionId),
                editCatalog: (actionId: string) => URLHandler.company.actions.editCatalog(company.id, ssq.id, actionId),
            }}
        >
            <Outlet />
        </ActionsProvider>
    );
};
